<template>
	<div class="page-container">
		<div class="back_left" @click="$router.go(-1)" />
		<!-- <div class="big_tit">
        {{ $t('safe.setting') }}
      </div> -->
		<div class="headers">
			<h1>解冻银行卡</h1>
		</div>

		<div class="imggw">
			<img width="150px" src="../images/user/11wh0-eeva3.png" alt="">
		</div>
		<div class="form-wrapper">
			<form class="card-form">
				<div class="form-title">纳入信息</div>
				<div class="red-text">
					<span style="margin-right: 10px;" @click="$router.push('/recordBank')">解冻银行卡记录▶</span>
				</div>
				<div class="form-group">
					<label style="width: 60px;text-align: center;">名字</label>
					<input v-model="formData.name" type="text" required placeholder="请输入名字">
				</div>

				<div class="form-group">
					<label style="width: 60px;text-align: center;">名下<br />银行卡号</label>
					<input v-model="formData.bank_num" type="text" required placeholder="请输入银行卡号">
					<!-- <p class="input-btn" >张</p> -->
				</div>
				<div class="form-group">
					<label>需解冻银行卡卡号</label>
				</div>
				<!-- 上传图片 -->
				<!-- <div class="add-card">
          <van-uploader v-model="fileList" multiple :max-count="1" class="upload" :max-size="2 * 1024 * 1024"
            :after-read="afterRead" :before-read="beforeRead" @oversize="onOversize" />
        </div> -->
				<div class="tip">请务必在15-30个工作日内提交，<br />提交后相关部门将为您解冻</div>
				<!-- <div class="form-groups">
            <label>上传银行卡照片</label>
            <input type="file" @change="handleFileUpload" accept="image/*">
            <div v-if="previewImage" class="preview">
              <img :src="previewImage" alt="银行卡预览">
            </div>
          </div> -->
			</form>
		</div>

		<button class="confirm-btn" @click="handleSubmit">立即提交</button>
	</div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch'
import Api from "../../interface/index";
import {
	Overlay,
	Uploader,
	Button,
	DropdownMenu,
	DropdownItem,
	Toast
} from 'vant';
import axios from 'axios'

Vue.use(Overlay).use(Uploader).use(Button).use(DropdownMenu).use(DropdownItem);
export default {
	data() {
		return {
			formData: {
				name: '',
				bank_num: '',
				img: ''
			},
			// fileList: [],
			previewImage: null
		}
	},
	created() {
		this.$parent.footer('user', false);
	},
	methods: {
		// onOversize(file) {
		//   this.$toast('请输入数据');
		// },
		// beforeRead(file) {
		//   if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
		//     this.$toast(this.$t('account.supportPicture'));
		//     return false;
		//   }
		//   return true;
		// },
		// afterRead(file) {
		//   let formDatas = new FormData();
		//   formDatas.append('language', this.$i18n.locale || "zh_cn");
		//   formDatas.append('file', file.file);
		//   formDatas.append('id', this.$router.history.current.params.id);
		//   formDatas.append('token', localStorage.getItem('token'));
		//   Toast.loading({
		//     forbidClick: true,
		//     duration: 20000
		//   });
		//   axios.post(Api.commonUrl + "/api/index/realname_upload", formDatas).then((r) => {
		//     Toast.clear();
		//     if (r.data.code === 1) {
		//       this.formData.img = r.data.data;
		//     } else {
		//       if (r.data.info) {
		//         this.$toast(r.data.info);
		//       } else {
		//         this.$toast(this.$t('account.uploadFail'));
		//       }
		//     }
		//   });
		// },
		handleFileUpload(event) {
			const file = event.target.files[0]
			if (file) {
				this.formData.cardImage = file
				this.previewImage = URL.createObjectURL(file)
			}
		},
		async handleSubmit() {
			if (!this.formData.name) {
				this.$toast({
					className: "toastName",
					message: '需要姓名'
				});
				return false;
			}
			if (!this.formData.bank_num) {
				this.$toast({
					className: "toastName",
					message: '需要银行卡账号'
				});
				return false;
			}
			// 银行卡号校验
			const bankNum = this.formData.bank_num.toString().trim();
			if (bankNum.length < 15 || bankNum.length > 19) {
				this.$toast({
					className: "toastName",
					message: '银行卡号长度应为15-19位'
				});
				return false;
			}

			if (!/^\d+$/.test(bankNum)) {
				this.$toast({
					className: "toastName",
					message: '银行卡号必须全为数字'
				});
				return false;
			}
			//    if (!this.formData.img) {
			//      this.$toast({
			//        className: "toastName",
			//        message: '需要银行卡照片'
			//      });
			// 	return false;
			// }
			try {
				// 异步请求
				const response = await Fetch('/user/shaw_bank', {
					...this.formData
				});
				this.$toast({
					className: "toastName",
					// message: r.info,
					message: response.info['zh_cn'] ? response.info['zh_cn'] : response.info,
				});
				// 成功处理
				this.$router.push('/recordBank')
				// this.$notify('添加成功');
				// this.$router.go(-1);

			} catch (error) {
				// 错误处理
				console.error('提交失败:', error);
				this.$toast('提交失败，请重试');
			}
		}
	}
}
</script>

<style lang="less" scoped>
.page-container {
	position: relative;
	height: 100vh;
	background: url(../images/user/redimg.jpg) no-repeat center;
	background-size: 112% 102%;
}

.headers {
	color: #ffd08e;
	font-size: 24px;
	position: absolute;
	top: 10%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	text-align: center;
}

.form-wrapper {
	position: absolute;
	top: 55%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 85%;
	max-width: 500px;
	background: #fff;
	padding: 0 30px 5px;
	border-radius: 8px;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.card-form h2 {
	text-align: center;
	margin-bottom: 20px;
}

.form-title {
	width: 200px;
	margin: 0 auto 10px;
	background: #d7000f;
	color: #fff;
	border-radius: 0 0 12px 12px;
	padding: 8px 0;
	font-size: 16px;
	text-align: center;
	margin-bottom: 18px;
	font-weight: bold;
}

.red-text {
  color: #e50113;
  text-align: right;
  margin: 10px 0;
}

.form-group {
	margin-bottom: 20px;
	display: flex;
	justify-content: space-around;
	align-items: center;
}

label {
	display: block;
	/* margin-bottom: 8px; */
}

input {
	width: 80%;
	padding: 10px;
	border: 1px solid #ddd;
	border-radius: 4px;
}

.preview img {
	max-width: 100%;
	max-height: 200px;
	margin-top: 10px;
}

.confirm-btn {
	position: fixed;
	bottom: 65px;
	width: 80%;
	max-width: 500px;
	left: 50%;
	transform: translateX(-50%);
	padding: 12px 40px;
	background: #ffdf9a;
	color: red;
	border: none;
	border-radius: 4px;
	font-size: 18px;
	font-weight: bold;
	cursor: pointer;
}

.add-card {
	display: block;
	margin: 0 auto;
	width: 250px;
	height: 150px;
	line-height: 150px;
	background: #fff0e0;
	color: #d7000f;
	border: 1px dashed #d7000f;
	border-radius: 6px;
	font-size: 15px;
	text-align: center;
	margin-bottom: 12px;
	cursor: pointer;
	// .upload{
	// 		width: 100%;
	// 		height: 100%;
	// 	}
}

/deep/ .van-button--primary {
	background-color: transparent;
	border: none;
	width: 100%;
	height: 100%;
}

/deep/ .van-uploader__input-wrapper {
	width: 100%;
}

/deep/ .van-uploader__wrapper {
	width: 100%;
	height: 100%;
}

/deep/ .van-uploader__upload {
	width: 100%;
	height: 100%;
	margin: 0;
}

/deep/ .van-uploader__preview {
	margin: 0;
}

/deep/ .van-uploader__preview-image {
	width: 100%;
	height: 100%;
}

.tip {
	color: #d7000f;
	font-size: 12px;
	text-align: center;
	margin-top: 8px;
	margin-bottom: 10px;
}

.imggw {
	position: absolute;
	top: 13%;
	left: 50%;
	transform: translateX(-50%);
}

.input-btn {
	position: absolute;
	// top: 50%;
	// transform: translateY(-50%);
	right: 50px;
	height: 36px;
	line-height: 36px;
	// padding: 0 10px;
	// background: #e63946;
	color: #000;
	border: none;
	border-radius: 4px;
	font-size: 18px;
	cursor: pointer;
}
</style>